import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subscription} from "rxjs";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute, Router} from "@angular/router";
import {Azienda} from "../../Admin/models/Azienda";

@Component({
  selector: 'app-lista-clienti',
  templateUrl: './lista-clienti.component.html',
})
export class ListaClientiComponent implements OnInit {
  @Input() Clienti: Azienda[] = [];
  @Output() ClientiChange = new EventEmitter<Azienda[]>();
  constructor(
    private modalService: NgbModal,
  ) {}

  ngOnInit() {

  }
  OpenMap(value: Azienda){
  }
}
